import { useNode } from "@craftjs/core";
import React from "react";
import { Resizable } from "../../input";
import { SpacerSettings } from "./settings";
import GrigoraCSSRenderer from "./../css-render";
import classNames from "classnames";
import icon from "./icon";
import { CMSSpacerSettings } from "./cms-settings";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";

export const Spacer = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
    dom,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
    dom: state.dom,
  }));

  const { width = "100%", height = "100px" } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-spacer": true,
      [`spacer-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
      style={{
        background: selected ? "#eeeeee" : undefined,
      }}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__Spacer(id, props)}`}</style>
      <Resizable
        className="resizable"
        nodeWidth={width}
        nodeHeight={height}
        onChange={(newWidth, newHeight) => {
          setProp((props) => {
            props.width = newWidth;
            props.height = newHeight;
          }, 300);
        }}
        selfWidth={"100%"}
        selfHeight={"100%"}
        percentSupport={true}
        percentReferenceElement={dom?.parentElement}
        active={selected}
      ></Resizable>
    </div>
  );
};

// To Avoid Mangling in Production
Spacer.displayName = "Spacer";

Spacer.craft = {
  name: "Spacer",
  props: {},
  related: {
    CMSsettings: CMSSpacerSettings,
    settings: SpacerSettings,
    icon: icon,
    CMSIcon: CMSIcon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "layout",
    keywords: ["Spacer", "Space", "Fill"],
  },
  custom: {
    name: "Spacer",
    slug: "grigora/spacer",
  },
};
